<template>
  <div class="facet-filter">
    <fn-items-list-item
      v-for="filter in facetItems"
      :key="filter.code"
      class="facet-filter-item"
      @delete="deleteFacetFilter(filter.parentFacet, filter.code)"
    >
      {{ filter.name }}
    </fn-items-list-item>
  </div>
</template>

<script>
export default {
  props: {
    facetItems: {
      type: Array,
      required: true,
    },
  },
  emits: ['deleteAllFacets'],
  methods: {
    removeFacetFromQuery(queryString, facet, code) {
      if (!queryString || !queryString.includes('::')) {
        return '';
      }

      if (!facet || !code) {
        return queryString;
      }

      // Prevent facet codes with braces to be evaluated as regex groups
      const codeEscaped = code.replace('(', '\\(').replace(')', '\\)');

      const regex = new RegExp(`:${facet}:${codeEscaped}:`);

      // Ensure that the last facet and code pair is surrounded by colons,
      // apply the regex replace and remove the appended colon again
      let updatedQueryString = `${queryString}:`;
      updatedQueryString = updatedQueryString.replace(regex, ':');
      updatedQueryString = updatedQueryString.slice(0, updatedQueryString.length - 1);

      return updatedQueryString;
    },

    deleteFacetFilter(parentFacet, code) {
      const query = { ...this.$route.query };
      const targetPath = this.$route.path.includes(this.$t('url.search')) ? this.$t('url.search') : this.$route.path;

      // Show loading spinner
      this.$emit('deleteAllFacets');

      query.q = this.removeFacetFromQuery(query.q, parentFacet, code);

      // Prevent empty param in URL
      if (query.q?.length <= 1) {
        delete query.q;
      }

      this.$router.push({
        path: targetPath,
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.facet-filter {
  align-self: flex-start;
  display: flex;
  flex-wrap: wrap;

  :deep(.facet-filter-item) {
    margin: 0 math.div($pad, 2) math.div($pad, 2) 0;
  }
}
</style>
